import { useCallback, useEffect, useRef, useState } from "react";
import { IStatisticsUsersResponse } from "../setup/api/services/stats/models";
import { getUserStats } from "../setup/api/services/stats";

const useGetUserStats = (organizationCode?: string) => {
  const [data, setData] = useState<
    IStatisticsUsersResponse["data"] | undefined
  >(undefined);
  const [loading, setLoading] = useState<boolean>(false);

  // Request ID to ignore stale responses
  const requestIdRef = useRef(0);

  const fetchUserStats = useCallback(async () => {
    // No need to check if organizationCode is available
    // We'll pass it to the API as is (undefined is valid)

    const requestId = ++requestIdRef.current;
    setLoading(true);

    try {
      const response = await getUserStats(organizationCode);

      // Ignore stale responses
      if (requestId !== requestIdRef.current) return;

      setData(response?.data);
    } catch (error) {
      if (requestId === requestIdRef.current) console.error(error);
    } finally {
      if (requestId === requestIdRef.current) setLoading(false);
    }
  }, [organizationCode]);

  useEffect(() => {
    fetchUserStats();
  }, [fetchUserStats]);

  return {
    data,
    loading,
  };
};

export default useGetUserStats;
